import memberServiceClient from "./client"
import { Response } from "../Model"
enum Device {
    MOBILE = `mobile`,
    WEB = `web`
}

interface CampaignResponse {
    banner_image: string,
    calling_app: string,
    fees_per_month_dec: number,
    fees_per_month_jan_nov: number,
    callback_url: string,
    campaign_end_date: string,
    campaign_start_date: string,
    upfront_payment_month: 0,
    sign_up_gift_description: string,
    sign_up_gift: boolean,
    campaign_name: string,
    campaign_code: string,
    id: string,
}

const getCampaign = (device: Device, campaignCode: string | undefined) => {
    return memberServiceClient.get<Response<CampaignResponse>>(
        `/campaign/${device}`,
        {
            params: {
                campaignCode: campaignCode,
            },
        },
    )
}

const getWebCampaign = (campaignCode: string | undefined) => {
    const url = new URL(window.location.href)

    if (campaignCode) {
        if (!url.searchParams.has(`utm_campaign`)) {
            url.searchParams.set(`utm_campaign`, campaignCode)
        }

        if (!url.searchParams.has(`CampaignCode`)) {
            url.searchParams.set(`CampaignCode`, campaignCode)
        }

        if (!url.searchParams.has(`utm_source`)) {
            url.searchParams.set(`utm_source`, campaignCode)
        }

        if (!url.searchParams.has(`utm_medium`)) {
            url.searchParams.set(`utm_medium`, campaignCode)
        }

        window.history.replaceState({}, ``, url.toString())
    }

    return getCampaign(Device.WEB, campaignCode)
}

const getMobileCampaign = (campaignCode: string | undefined) => {
    return getCampaign(Device.MOBILE, campaignCode)
}

export { getCampaign, getWebCampaign, getMobileCampaign }
